<template>
    <div class="vm-radio-icon">

    </div>
</template>

<script>

export default {
    name: 'radio-icon',
    props: {
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style lang="stylus" scoped>
.vm-radio-icon{
    border-radius 1000px
    border 2px solid $black-3
    display flex
    align-items center
    justify-content center
    padding px2rem(4)
    cursor pointer
    &:after{
        content ''
        display block
        border-radius 1000px
        background transparent
        height px2rem(8)
        width px2rem(8)
    }
    &.on{
        border-color $purple
        &:after{
            background $purple
        }
    }
}
</style>
